<!--
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-30 23:18:09
 * @LastEditors: Francis
 * @LastEditTime: 2022-07-31 02:44:10
-->
<template>
  <div class="auditWork">
    <Header
      menuName="workOrder"
      :keyWord.sync="keyWord"
      pageName="工单"
      :component.sync="component"
    ></Header>
    <Footer :page="0" :mineActive="2"></Footer>
    <div class="workList" ref="workListbox">
      <van-pull-refresh
        v-model="refreshing"
        success-text="刷新成功"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :immediate-check="false"
          :offset="100"
        >
          <listItem
            v-for="(item, index) in tableList"
            :key="index"
            :info="item"
            :type.sync="component"
            @action="action"
          ></listItem>
        </van-list>
      </van-pull-refresh>
    </div>
    <van-overlay :show="show" z-index="999">
      <div class="wrapper">
        <div class="block">
          <p class="title">退回工单原因：</p>
          <textarea
            v-model="reason"
            class="area"
            maxlength="50"
            placeholder="请输入退回工单原因"
          ></textarea>
          <div class="reject" @click="onClickState(1)">取消</div>
          <div class="pass" @click="onClickState(2)">退回</div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import Header from "@/components/Header";
import { workOrderList, handleOrder } from "@/utils/network/interface";
import listItem from "./components/item";
// import AMap from "AMap";
import { getAMap } from "@/utils/amap";
export default {
  name: "auditWork",
  components: {
    Footer,
    Header,
    listItem,
  },
  props: {},
  data() {
    return {
      reason: "",
      show: false,
      keyWord: "",
      component: "",
      tableList: [],
      refreshing: false,
      loading: false,
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      finished: false,
      item: null,
      address: "",
    };
  },
  computed: {},
  watch: {
    keyWord(newVal, oldVal) {
      // this.finished = false;
      this.pageInfo.pageNum = 1;
      this.tableList = [];
      // this.onLoad();
      this.getData();
      // this.pageInfo.pageNum++;
    },
    component(newVal, oldVal) {
      this.tableList = [];
      this.finished = false;
      this.loading = true;
      this.keyWord = "";
      this.pageInfo.pageNum = 1;
      this.getData();
      // this.pageInfo.pageNum++;
    },
  },
  created() {
    if (this.$route.query) {
      // console.log(this.component)
      this.component = this.$route.query.component;
    }
    // this.getCity();
    // this.getlocation();
  },
  beforeCreate() {},
  mounted() {
    // this.onLoad()
  },
  methods: {
    // 修改天地图获取城市
    getlocation() {
      return new Promise(async (resolve, reject) => {
        let _this = this;
        let local = new T.Geolocation();
        local.getCurrentPosition(function(GeolocationResult) {
          console.log(GeolocationResult);
          let geocoder = new T.Geocoder();
          geocoder.getLocation(GeolocationResult.lnglat, function(
            GeocoderResult,
          ) {
            console.log(GeocoderResult);
            _this.address = GeocoderResult.getAddressComponent();
            resolve(_this.address);
          });
        });
      });
    },
    // getlocation() {
    //   return new Promise(async (resolve, reject) => {
    //     let _this = this;
    //     const AMap = await getAMap();
    //     AMap.plugin("AMap.Geolocation", () => {
    //       const geolocation = new AMap.Geolocation({
    //         enableHighAccuracy: true,
    //         timeout: 10000,
    //         enableIPLocation: true, // 强制开启IP定位兜底
    //         disableGeoLocation: false,
    //       });

    //       geolocation.getCurrentPosition((status, result) => {
    //         if (status === "complete") {
    //           const { position } = result;
    //           console.log("经度:", position.lng);
    //           console.log("纬度:", position.lat);
    //           AMap.plugin("AMap.Geocoder", function() {
    //             let geocoder = new AMap.Geocoder({});
    //             let positionnum = [position.lng, position.lat];
    //             geocoder.getAddress(positionnum, function(
    //               endstatus,
    //               enderesult,
    //             ) {
    //               console.log(endstatus, enderesult);

    //               if (endstatus === "complete" && enderesult.info === "OK") {
    //                 // result为对应的地理位置详细信息
    //                 _this.address = enderesult.regeocode.addressComponent;
    //                 resolve(_this.address);
    //               } else {
    //                 reject(result);
    //               }
    //             });
    //           });
    //         } else {
    //           reject(result);
    //           console.error("定位失败", result);
    //         }
    //       });
    //     });
    //   });
    // },
    async getCity() {
      let _this = this;
      const AMap = await getAMap();

      AMap.plugin("AMap.Geolocation", function() {
        const geolocation = new AMap.Geolocation({
          enableHighAccuracy: false, // 是否使用高精度定位
          timeout: 10000, // 超时时间
          showButton: false, // 是否显示定位按钮
          zoomToAccuracy: false, // 定位成功后调整地图视野范围
        });
        geolocation.getCityInfo(function(status, result) {
          if (status === "complete") {
            //  不知道为什么有时候city是空，判断加一层反解析
            console.log(status, result);
            result.city = null;
            if (!result.city) {
              AMap.plugin("AMap.Geocoder", function() {
                let geocoder = new AMap.Geocoder({
                  city: "010", // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
                });
                geocoder.getAddress(result.position, function(
                  endstatus,
                  enderesult,
                ) {
                  console.log(endstatus, enderesult);

                  if (endstatus === "complete" && enderesult.info === "OK") {
                    // result为对应的地理位置详细信息
                    _this.address = enderesult.regeocode.addressComponent;
                  }
                });
              });
            } else {
              _this.address = result;
            }
          }
        });
      });
      // return;
      // let _this = this;
      // var geolocation = new BMap.Geolocation();
      // geolocation.getCurrentPosition(function(r) {
      //   _this.address = r.address;
      //   console.log(_this.address, "1");
      //   if (this.getStatus() == BMAP_STATUS_SUCCESS) {
      //     _this.address = r.address;
      //     console.log(_this.address, "2");
      //   }
      // });
    },
    onLoad() {
      setTimeout(() => {
        const { pageSize, pageNum } = this.pageInfo;
        let obj = { pageSize, pageNum };
        let typeList = {
          workList1: 1,
          workList2: 2,
          workList3: 3,
          workList4: 4,
        };
        let params = {
          bizName: this.keyWord,
          type: typeList[this.component],
          ...obj,
        };
        workOrderList(params)
          .then((res) => {
            if (res.code === 200) {
              if (res.rows == null || res.rows.length == 0)
                return (
                  (this.finished = true),
                  (this.loading = false),
                  (this.page.pageNum = 1),
                  (this.tableList = [])
                );
              this.tableList = this.tableList.concat(res.rows);
              this.pageInfo.pageNum++;
              this.pageInfo.total = res.total;
              this.loading = false;
              if (this.tableList.length >= res.total) {
                this.finished = true;
              }
            } else {
              this.finished = true;
            }
          })
          .catch((err) => {});
      }, 500);
    },
    getData() {
      let obj = { pageSize: 10, pageNum: 1 };
      let typeList = { workList1: 1, workList2: 2, workList3: 3, workList4: 4 };

      let params = {
        bizName: this.keyWord,
        type: typeList[this.component],
        ...obj,
      };
      workOrderList(params)
        .then((res) => {
          this.refreshing = false;
          this.loading = false;

          if (res.code == 200) {
            if (res.rows == null || res.rows.length == 0) {
              this.finished = true;
              this.loading = false;
              this.pageInfo.pageNum = 1;
              this.tableList = [];
            } else {
              this.tableList = res.rows;
              this.pageInfo.pageNum++;
              this.pageInfo.total = res.total;
            }
          } else {
            this.tableList = [];
          }
        })
        .catch((err) => {});
    },
    onRefresh() {
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.pageInfo.pageNum = 1;
      this.getData();
      // this.pageInfo.pageNum++;
    },
    async action(item, methods) {
      // console.log(item)
      this.item = item;
      // this.show = true
      if (methods == 1) {
        //接单
        handleOrder({ id: item.id, type: 1 }).then((res) => {
          if (res.code === 200) {
            this.$toast.success("接单成功");
            this.getData();
          }
        });
      } else if (methods == 2) {
        // 打卡
        // dkWorkOrder

        await this.getlocation();

        let params = {
          id: item.id,
          type: 3,
          location: this.address.city,
        };
        console.log(params);
        handleOrder({ id: item.id, type: 3, location: this.address.city }).then(
          (res) => {
            if (res.code === 200) {
              this.$toast.success("打卡成功");
              this.getData();
            }
          },
        );
      } else if (methods == 3) {
        // 退回
        this.show = true;
      }
    },
    onClickState(type) {
      if (type == 1) {
        this.reason = "";
        this.show = false;
        return;
      }
      if (this.reason.length <= 0) return this.$toast("请先输入原因");
      handleOrder({
        id: this.item.id,
        returnReason: this.reason,
        type: 2,
      })
        .then((res) => {
          if (res.code === 200) {
            this.show = false;
            this.reason = "";
            this.$toast.success("回退成功");
            this.getData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.auditWork {
  padding-top: 220px;
  padding-bottom: 70px;

  .workList {
    height: 100%;
    min-height: 500px;
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    z-index: 9999999;

    .block {
      width: 269px;
      height: 249px;
      background-size: 269px 60px;
      background-color: white;
      border-radius: 10px;
      text-align: center;

      .title {
        font-size: 16px;
        color: black;
        margin-top: 18px;
        margin-left: 20px;
        font-weight: 700;
        margin-bottom: 13px;
        text-align: left;
      }

      .sub_title {
        margin: 0 auto;
        margin-bottom: 13px;
        border-left: 2px solid #44b1f9;
        font-size: 13px;
        color: black;
        width: 80%;

        span {
          color: #5e5e5e;
        }
      }

      .img_arr {
        display: flex;
        width: 80%;
        margin: 0 auto;

        img {
          width: 51px;
          height: 51px;
          margin-right: 9px;
        }
      }

      .area {
        margin: 0 auto;
        width: 242px;
        height: 107px;
        background: #eeeeee;
        border: 1px solid #44b1f9;
        border-radius: 5px;
        margin-bottom: 16px;
        box-sizing: border-box;
        padding: 10px;
        resize: none;
      }

      .reject {
        width: 87px;
        height: 28px;
        border-radius: 5px;
        background-color: #999999;
        color: white;
        text-align: center;
        line-height: 28px;
        float: left;
        margin-top: 20px;
        margin-left: 40px;
      }

      .pass {
        width: 87px;
        height: 28px;
        border-radius: 5px;
        color: white;
        text-align: center;
        line-height: 28px;
        background-color: #44b1f9;
        float: left;
        margin-top: 20px;
        margin-left: 20px;
      }
    }
  }
}
</style>
